import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import * as Yup from "yup";
import { ClientDetailDto } from "src/store/clients/type";
import { createClientLocation } from "src/store/clients/saga";

const LocationCreateForm = ({
  onHide,
  open,
  onSuccessClick,
  client,
}: {
  client: ClientDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Clients.Locations.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          ClientId: client.Id,
          LocationTitle: "",
          AddressDetail: "",
          Default: true,
          Latitude: "",
          Longitude: "",
        }}
        validationSchema={Yup.object().shape({
          ClientId: Yup.string().required(t("Required").toString()),
          Latitude: Yup.string().required(t("Required").toString()),
          Longitude: Yup.string().required(t("Required").toString()),
          LocationTitle: Yup.string().required(t("Required").toString()),
          AddressDetail: Yup.string().required(t("Required").toString()),
        })}
        onSubmit={(values) => {
          dispatch(
            createClientLocation({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        inputs={[
          {
            field: "LocationTitle",
            label: t("Clients.Locations.Title").toString(),
          },
          {
            field: "LocationTitle",
            label: t("Clients.Locations.AddressDetail").toString(),
            type: "textarea",
          },
          {
            field: "Default",
            label: t("Clients.Locations.Default").toString(),
            type: "switch",
            col: 6,
          },
          {
            field: "Longitude",
            label: "",
            googlemap: {
              latField: "Latitude",
              lonField: "Longitude",
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default LocationCreateForm;
